export const APP_VERSION = '3.88.1';
